export default "__VITE_ASSET__CxHpzaqL__"